



























import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import authService from "@/components/domains/auth/authService";
import PasswordlessService, {clearUrlFragment} from "@/components/domains/auth/passwordlessService";
import {toAuthError, tokenFromHash} from "@/components/domains/auth/authPolicy";

const NO_TOKEN = 'このリンクは使えません。もう一度ログイン用のメールを送ってください。';

/**
 * Landing page of the mailed sign-in link (`/login/magic-link#token=…`).
 * Opening the page does NOT sign in (mail clients pre-fetch links) — the
 * 「ログインする」 button does.
 */
@Component({
  components: {DefaultTemplate}
})
export default class MagicLinkLanding extends Vue {
  name = "MagicLinkLanding";

  token = '';
  phase: 'ready' | 'working' | 'failed' = 'ready';
  errorMsg = '';

  mounted(): void {
    this.readToken();
    window.addEventListener('hashchange', this.readToken);
  }

  beforeDestroy(): void {
    window.removeEventListener('hashchange', this.readToken);
  }

  readToken(): void {
    const next = tokenFromHash(window.location.hash);
    clearUrlFragment();
    // Another link opened in this same tab changes only the hash (no remount).
    if (next) {
      this.token = next;
      this.errorMsg = '';
      this.phase = 'ready';
    } else if (!this.token) {
      this.errorMsg = NO_TOKEN;
      this.phase = 'failed';
    }
  }

  async handleLogin(): Promise<void> {
    if (!this.token || this.phase === 'working') return;
    this.phase = 'working';
    try {
      await PasswordlessService.verifyMagicLink(this.token);
    } catch (e) {
      // The token is spent or bad either way; don't offer to press again.
      this.token = '';
      this.errorMsg = toAuthError(e, NO_TOKEN).message;
      this.phase = 'failed';
      return;
    }
    // Same post-login path as the password login.
    await authService.authMe();
    this.$router.push('/');
  }
}
